<template lang="pug">
div.boxSectionHeaderAndBody
  div#navtop(:class="{'anchoEscritorioSubnavCerrado': subNavClosed}")
    div.sectionmenu
      div.firstlevel
        router-link(:to="{name: 'DeliveryResumeHome', params: {paramCOD: this.paramCOD}, query: queryParams}") #[translate Resume]
        router-link(:to="{name: 'DeliveryRequestedDataHome', params: {paramCOD: this.paramCOD}, query: queryParams}") #[translate Orders]
        router-link(:to="{name: 'DeliveryRankingRestaurantsHome', params: {paramCOD: this.paramCOD}, query: queryParams}") #[translate Ranking]
        router-link(:to="{name: 'DeliveryGPSHome', params: {paramCOD: this.paramCOD}, query: queryParams}") #[translate GPS]
        router-link(v-if="nodeLevel  && hasCompetence" :class="{'router-link-active': ['DeliveryCompetenceGlobal', 'DeliveryCompetenceMap'].includes($route.name) }" :to="{name: 'DeliveryCompetenceHome', params: {paramCOD: this.paramCOD}, query: queryParams}") #[translate Competence]
        router-link.text-no-wrap(v-if="nodeLevel" :class="{'router-link-active': ['IndividualDeliveryCompetenceGlobal', 'IndividualDeliveryCompetenceCompareLocals'].includes($route.name) }" :to="{name: 'DeliveryIndividualCompetence', params: {paramCOD: this.paramCOD}, query: queryParams}") #[translate Comparador de marca]
        router-link(v-if="hasDeliveryAnalytics" :to="{name: 'DeliveryPosicionamientoHome', params: {paramCOD: this.paramCOD}, query: queryParams}") #[translate Pos. Webs Delivery]
        select-country-and-logout
      div.secondlevel(:class="{'d-none': this.$router.history.current.name.indexOf('DeliveryValoration') < 0 && this.$router.history.current.name.indexOf('DeliveryCompetence') < 0}")
        .submenuValoration
          router-link(v-if="!['IndividualDeliveryCompetenceGlobal', 'IndividualDeliveryCompetenceCompareLocals'].includes($router.history.current.name)" :to="{name: 'DeliveryCompetenceGlobal', params: {paramCOD: this.paramCOD}, query: queryParams}") #[translate Global]
          router-link(v-else :to="{name: 'IndividualDeliveryCompetenceGlobal', params: {paramCOD: this.paramCOD}, query: queryParams}") #[translate Global]
          router-link(v-if="($config.featureConfig.mapCompetence || userName.indexOf('gastroranking.es') > -1 || userName.indexOf('theysay.me') > -1) && hasCompetence && !['IndividualDeliveryCompetenceGlobal', 'IndividualDeliveryCompetenceCompareLocals'].includes($router.history.current.name)" :to="{name: 'DeliveryCompetenceMap', params: {paramCOD: this.paramCOD}, query: queryParams}") #[translate Map]

          router-link(v-if="!['IndividualDeliveryCompetenceGlobal', 'IndividualDeliveryCompetenceCompareLocals'].includes($router.history.current.name) && ($config.featureConfig.mapCompetence || userName.indexOf('gastroranking.es') > -1 || userName.indexOf('theysay.me') > -1)" :to="{name: 'DeliveryCompetenceCompareLocals', params: {paramCOD: this.paramCOD}, query: queryParams}")
            span(v-if="isGenericEntity") #[translate Comparar negocios]
            span(v-else) #[translate Comparar locales]
          router-link(v-else-if="$config.featureConfig.mapCompetence || userName.indexOf('gastroranking.es') > -1 || userName.indexOf('theysay.me') > -1" :to="{name: 'IndividualDeliveryCompetenceCompareLocals', params: {paramCOD: this.paramCOD}, query: queryParams}")
            span(v-if="isGenericEntity") #[translate Comparar negocios]
            span(v-else) #[translate Comparar locales]


  div.gridSection
    div.sectionmenu
      filters-and-bread-crumb(:paramCOD="paramCOD" :isDelivery="true")
      warning-not-delivery-not-internet(v-if="itemNotHasDelivery" type="delivery")
      router-view.bg-gray.pt-0

</template>

<script>
import FiltersAndBreadCrumb from "@/components/filters/filtersAndBreadCrumb.vue"
import SelectCountryAndLogout from "@/components/common/SelectCountryAndLogout.vue"

import * as types from '@/store/mutation-types'
import commonMixins from "@/mixins/common.js"
import brandMixin from "@/mixins/common.js"
import WarningNotDeliveryNotInternet from '@/components/common/WarningNotDeliveryNotInternet.vue'
export default {
  props: ['paramCOD', 'type', 'site', 'typeRestaurant', 'after', 'before'],
  mixins: [commonMixins, brandMixin],
  data() {
    return {
    }
  },
  components: { FiltersAndBreadCrumb, WarningNotDeliveryNotInternet, SelectCountryAndLogout },
  created() {
    this.$store.commit(types.UPDATE_SECTION, 8)
    this.loadUrlParams()

  },
  watch: {
    filterForSites: function () {
      this.$store.dispatch('getSitesOpinions')
    },
  },
}
</script>

